import React from 'react';
import { CapacityManagementDrillDownItem } from 'types/store/normalized/insightsDrillDown';
import CapacityManagementDrillDownTableRow from '../CapacityManagementDrillDownTableRow/CapacityManagementDrillDownTableRow';

type CapacityManagementDrillDownTableBodyProps = {
  items: Array<CapacityManagementDrillDownItem>;
};

const CapacityManagementDrillDownTableBody: React.FC<
  CapacityManagementDrillDownTableBodyProps
> = ({ items }) => {
  return (
    <tbody>
      {items.map((item) => (
        <CapacityManagementDrillDownTableRow key={item.id} item={item} />
      ))}
    </tbody>
  );
};

export default CapacityManagementDrillDownTableBody;
